// Constants
  const entryAgeModal = document.getElementById("entry-age-modal");
  const entryAgeModalConfirm = document.getElementById("entry-age-modal-confirm");
  const entryAgeModalDeny = document.getElementById("entry-age-modal-deny");
// End Constants
  
// Functions
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function openEntryAgeModal() {
  entryAgeModal.classList.add("is-active");
}

function closeEntryAgeModal() {
  entryAgeModal.classList.remove("is-active");
}
// End Functions
  
// Event Listeners
  entryAgeModalConfirm.addEventListener('click', function() {
    setCookie("entry-age-verified", true);
    closeEntryAgeModal();
  })
  //  Added a redirect url to customize section so it can be easily changed
  
// End Event Listeners

// On window load, check for verified cookie


setTimeout(() => {
  if (!getCookie("entry-age-verified")) {
	openEntryAgeModal();	 
  };        
}, 1000);